import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Partner-specific configs
import homiqConfig, { getConfig } from './homiq/config';
import instaviewConfig, { getInstaViewConfig } from './instaview/config';
import lunaConfig, { getLunaConfig } from './luna/config';

// Partner-specific themes
import homiqTheme from './homiq/theme';
import instaviewTheme from './instaview/theme';
import lunaTheme from './luna/theme';

// Partner name type
type PartnerName = 'luna' | 'instaview' | 'homiq';

const PARTNER = process.env.REACT_APP_PARTNER || 'instaview';

const getPartnerDetails = () => {
  switch (PARTNER) {
    case 'homiq':
      return {
        config: homiqConfig,
        theme: homiqTheme,
        name: 'homiq' as PartnerName
      };

    case 'luna':
      return {
        config: lunaConfig,
        theme: lunaTheme,
        name: 'luna' as PartnerName
      };

    case 'instaview':
    default:
      return {
        config: instaviewConfig,
        theme: instaviewTheme,
        name: 'instaview' as PartnerName
      };
  }
};

const { config, theme, name } = getPartnerDetails();
export { config, name, theme };

export const usePartnerConfig = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'partnerConfig'
  });

  const translatedConfig = useMemo(() => {
    switch (name) {
      case 'homiq':
        return getConfig(t);
      case 'luna':
        return getLunaConfig(t);
      case 'instaview':
      default:
        return getInstaViewConfig(t);
    }
  }, [t]);

  return {
    config: translatedConfig,
    theme,
    name
  };
};

export const getPartnerName = (): PartnerName => {
  return name;
};
